module.exports = __webpack_public_path__ + "media/images/video-icon-0889fef7ec684d7556da7e07f7664d6ee927836a85f240737af366708bed3a4e.svg";